module.exports = __webpack_public_path__ + "static/media/no.b330e019.png";